export function resizeImage({
  url,
  width,
  height,
  fit=`cover`,
  format=`jpeg`,
}) {
  if (!url) return ``;

  let bucket;
  let key;

  if (url.startsWith(`https://s3.entegral.net/`)) {
    bucket = `s3.entegral.net`;
    key = url.replace(`https://s3.entegral.net/`, ``);
  }

  if (url.startsWith(`https://s3-eu-west-1.amazonaws.com/etoms/`)) {
    bucket = `etoms`;
    key = url.replace(`https://s3-eu-west-1.amazonaws.com/etoms/`, ``);
  }

  if (bucket && key) {
    let params = {
      bucket,
      key,
      format,
      edits: {
        resize: {
          width,
          height,
          fit,
        },
      },
    };

    return `https://resizer.entegral.net/${btoa(JSON.stringify(params))}`;
  }

  return url;
}
